<template>
	<div class="form-group">
		<label class="font-weight-bold">{{ label }}</label>
		<div class="custom-file">
			<input
				type="file"
				class="custom-file-input"
				:id="inputID"
				:disabled="loading"
				ref="fileInput"
				@change="filesChange"
			/>
			<label class="custom-file-label" :for="inputID">
				{{ label }}
			</label>
		</div>
	</div>
</template>

<script>
import FileInput from '../../components/Inputs/FileInput'

import api from '../../services'

export default {
	props: ['label', 'setting', 'params'],
	components: {
		FileInput,
	},
	data() {
		return {
			loading: false,
			inputID: `fileUpload${this.setting}`,
		}
	},
	methods: {
		async filesChange(e) {
			const files = e.target.files
			if (files.length <= 0) return false

			const formData = new FormData()
			formData.append('setting', this.setting)
			formData.append('file', files[0])

			try {
				this.loading = true

				const res = await api.post('/upload', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
					params: this.params || {},
				})
				this.$notify({ type: 'success', message: res.message })

				this.$emit('uploaded')
			} catch ({ message }) {
				this.$notify({ type: 'danger', message })
			} finally {
				this.loading = false

				const input = this.$refs.fileInput
				input.type = 'text'
				input.type = 'file'
			}
		},
	},
}
</script>
